// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Color } from '../../../Graphics';
import { LineStyle } from '../IndicatorScriptBaseEnums';
import { IndicatorScriptBase } from '../IndicatorScriptBase';
export class AO extends IndicatorScriptBase {
    constructor() {
        super();
        this.ProjectName = 'Awesome Oscillator';
        this.Comments = 'Awesome Oscillator';
        super.SetIndicatorLine('asc', Color.Green, 1, LineStyle.HistogrammChart);
        super.SetIndicatorLine('desc', Color.Red, 1, LineStyle.HistogrammChart);
        this.SeparateWindow = true;
    }
    Init() {
        super.Init();
        super.IndicatorShortName(this.GetIndicatorShortName());
    }
    GetIndicatorShortName() {
        return 'AO';
    }
    getCustomName() {
        return 'AO (' + this.ProjectName + ')';
    }
    createInternalIndicators() {
        this.ao = this.Indicators.iAO(this.CurrentData);
        super.IndicatorShortName(this.GetIndicatorShortName());
        return [this.ao];
    }
    OnQuote() {
        super.OnQuote();
        if (this.CurrentData.Count >= 2) {
            const curr = this.ao.GetValue();
            const prev = this.ao.GetValue(1);
            if (prev < curr) {
                super.SetValue(0, curr);
                super.SetValue(1, 0);
            }
            else if (prev > curr) {
                super.SetValue(0, 0);
                super.SetValue(1, curr);
            }
            else {
                super.SetValue(0, 0);
                super.SetValue(1, 0);
            }
        }
        else {
            super.SetValue(0, 0);
            super.SetValue(1, 0);
        }
    }
}
